module.exports = __webpack_public_path__ + "static/13-88f357ccd3a2de86588f0022e0ad1f74.jpg";